import { Building2, Check, ChevronsUpDown } from "lucide-react";
import { useTranslation } from "react-i18next";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useAuth } from "@/lib/auth";
import { cn } from "@/lib/utils";

export function TenantSwitcher({ collapsed = false }: { collapsed?: boolean }) {
  const { t } = useTranslation();
  const { tenant, memberships, switchTenant } = useAuth();
  if (!tenant) return null;
  const single = memberships.length <= 1;

  const content = (
    <span className={cn("flex w-full items-center gap-2.5 rounded-lg border bg-background px-2.5 py-2 text-left", collapsed && "justify-center px-0")}>
      <Building2 className="size-4 shrink-0 text-muted-foreground" />
      {!collapsed && (
        <>
          <span className="min-w-0 flex-1 truncate text-[13px] font-medium">{tenant.tenant_name}</span>
          {!single && <ChevronsUpDown className="size-3.5 text-muted-foreground" />}
        </>
      )}
    </span>
  );
  if (single) return content;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="w-full rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-ring/40">{content}</DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-60">
        <DropdownMenuLabel className="text-xs font-normal text-muted-foreground">{t("auth.select_tenant")}</DropdownMenuLabel>
        {memberships.map((m) => (
          <DropdownMenuItem key={m.tenant_id} onClick={() => switchTenant(m.tenant_id)}>
            <span className="flex-1 truncate">{m.tenant_name}</span>
            {m.tenant_id === tenant.tenant_id && <Check className="size-4" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
